export enum DisplayRequestType {
  ORDER_DISCOUNT = 'Order discount',
  TRIAL_EXTENSION = 'Trial extension',
  TAX_REFUND = 'Tax refund',
  SUBSCRIPTION_REFUND = 'Subscription refund',
  PRODUCT_DELETION = 'Data deletion',
  QUOTE_DISCOUNT = 'Quote discount',
  QUOTE_EXTENSION = 'Quote extension',
  PRICING_PLAN_CHANGE = 'Pricing plan change',
  CLOUD_SITE_DELETION = 'Cloud site deletion',
}
